
import { defineComponent, ref } from 'vue';
import InputText from '@/components/input/InputText.vue';
import InputDate from '@/components/input/InputDate.vue';
import InputTextArea from '@/components/input/InputTextArea.vue';
import InputImageCostume from '@/components/input/InputImageCostume.vue';
import { useStore } from 'vuex';
import { POST_ACTIVITY, PUT_ACTIVITY } from "@/store/activity.module";
import { POST_IMAGE } from "@/store/upload.module";

export default defineComponent({
  components: {
    InputText,
    InputDate,
    InputTextArea,
    InputImageCostume,
  },
  props: {
    title: {
      type: String,
      required: true
    },
    id:{
      type: String,
      required: false
    },
    data: {
      type: Object,
      required: false,
      default: () => ({}) // Provide a default object to prevent undefined errors
    }
  },
  setup(props, { emit }) {
    const store = useStore();
    const modalContent = ref(null);
    const isLoading = ref(false);

    const closeModal = () => {
      isLoading.value = false;
      emit('close');
    };

    const formData = {
      id: '',
      data: {} as Record<string, any>
    }

    const updateValue = (params: { key: string; value: any }) => {
      formData.data[params.key] = params.value;
    };

    const handleSubmit = async () => {
      isLoading.value = true;
      try {
        if(formData?.data?.image){
          if(typeof formData?.data?.image !== "string") {
            const response = await store.dispatch(POST_IMAGE, formData);
            formData.data.image = response || "";
          }
          formData.data.image = formData?.data?.image || "";
        }

        if(props?.id){
          formData.id = props?.id
          await store.dispatch(PUT_ACTIVITY, formData);
        }else{
         await store.dispatch(POST_ACTIVITY, formData);
        }
        closeModal();
      } catch (error:any) {
        alert(error?.response?.data?.message);
        isLoading.value = false;
      }
    };

    return {
      modalContent,
      closeModal,
      handleSubmit,
      updateValue,
      isLoading
    };
  },
});
